/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VorlagenwechselZuordnung
 */
export interface VorlagenwechselZuordnung {
    /**
     * 
     * @type {string}
     * @memberof VorlagenwechselZuordnung
     */
    quellFeldId?: string;
    /**
     * 
     * @type {string}
     * @memberof VorlagenwechselZuordnung
     */
    quellName?: string;
    /**
     * 
     * @type {string}
     * @memberof VorlagenwechselZuordnung
     */
    quellTyp?: string;
    /**
     * 
     * @type {string}
     * @memberof VorlagenwechselZuordnung
     */
    zielFeldId?: string;
    /**
     * 
     * @type {string}
     * @memberof VorlagenwechselZuordnung
     */
    zielName?: string;
    /**
     * ROLLE = ueber die Template-Rolle zugeordnet, NAME = ueber Name und Typ, NEU = wird angelegt
     * @type {string}
     * @memberof VorlagenwechselZuordnung
     */
    art?: VorlagenwechselZuordnungArtEnum;
    /**
     * Am Wert haengt eine Datei. Wird das Feld abgewaehlt, wird sie nicht kopiert.
     * @type {boolean}
     * @memberof VorlagenwechselZuordnung
     */
    binaer?: boolean;
    /**
     * false bei neu angelegten Feldern — sie haben keine Position im Karten-Raster
     * @type {boolean}
     * @memberof VorlagenwechselZuordnung
     */
    aufKarteSichtbar?: boolean;
    /**
     * Versandtermin — wird auf die naechste Gelegenheit gesetzt
     * @type {boolean}
     * @memberof VorlagenwechselZuordnung
     */
    terminWirdWeitergedreht?: boolean;
}


/**
 * @export
 */
export const VorlagenwechselZuordnungArtEnum = {
    Rolle: 'ROLLE',
    Name: 'NAME',
    Neu: 'NEU'
} as const;
export type VorlagenwechselZuordnungArtEnum = typeof VorlagenwechselZuordnungArtEnum[keyof typeof VorlagenwechselZuordnungArtEnum];


/**
 * Check if a given object implements the VorlagenwechselZuordnung interface.
 */
export function instanceOfVorlagenwechselZuordnung(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VorlagenwechselZuordnungFromJSON(json: any): VorlagenwechselZuordnung {
    return VorlagenwechselZuordnungFromJSONTyped(json, false);
}

export function VorlagenwechselZuordnungFromJSONTyped(json: any, ignoreDiscriminator: boolean): VorlagenwechselZuordnung {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quellFeldId': !exists(json, 'quellFeldId') ? undefined : json['quellFeldId'],
        'quellName': !exists(json, 'quellName') ? undefined : json['quellName'],
        'quellTyp': !exists(json, 'quellTyp') ? undefined : json['quellTyp'],
        'zielFeldId': !exists(json, 'zielFeldId') ? undefined : json['zielFeldId'],
        'zielName': !exists(json, 'zielName') ? undefined : json['zielName'],
        'art': !exists(json, 'art') ? undefined : json['art'],
        'binaer': !exists(json, 'binaer') ? undefined : json['binaer'],
        'aufKarteSichtbar': !exists(json, 'aufKarteSichtbar') ? undefined : json['aufKarteSichtbar'],
        'terminWirdWeitergedreht': !exists(json, 'terminWirdWeitergedreht') ? undefined : json['terminWirdWeitergedreht'],
    };
}

export function VorlagenwechselZuordnungToJSON(value?: VorlagenwechselZuordnung | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quellFeldId': value.quellFeldId,
        'quellName': value.quellName,
        'quellTyp': value.quellTyp,
        'zielFeldId': value.zielFeldId,
        'zielName': value.zielName,
        'art': value.art,
        'binaer': value.binaer,
        'aufKarteSichtbar': value.aufKarteSichtbar,
        'terminWirdWeitergedreht': value.terminWirdWeitergedreht,
    };
}

